"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Radar = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "3 3 18 18"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "#6E7F96",
  className: "fill"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 3l.117.007A1 1 0 0112 5a7 7 0 104.95 2.051l1.415-1.414A9 9 0 1112 3zm0 4l.117.007A1 1 0 0112 9a3 3 0 102.122.88l1.415-1.415A5 5 0 1112 7z"
}), /*#__PURE__*/_react.default.createElement("rect", {
  transform: "rotate(45 14.828 9.172)",
  x: 13.828,
  y: 4.172,
  width: 2,
  height: 10,
  rx: 1
})));
var _default = exports.default = Radar;